/**
 * WebIME関連のメソッド群
 */
export class WebimeUtils {
  /**
   * スタイルのコピー
   */
  private static cloneElem(elOriginal: HTMLInputElement, elClone: HTMLElement): void {
    const styleOriginal = getComputedStyle(elOriginal, '')

    for (let i = styleOriginal.length; i--; ) {
      const key = styleOriginal[i]

      // textFillColor属性があるとcolor属性がわからなくなるので除外
      if (key.includes('text-fill-color')) {
        continue
      }
      elClone.style[key] = styleOriginal.getPropertyValue(key)
    }
  }

  /**
   * 選択範囲のテキストボックス内の相対座標の範囲を取得
   */
  private static getBounds(elem: HTMLInputElement): { left: number; top: number; width: number; height: number } {
    // ダミー要素を作成
    const cloneEl = document.createElement('pre')
    this.cloneElem(elem, cloneEl)
    if (elem.offsetParent) elem.offsetParent.appendChild(cloneEl)

    const selectionStart = elem.selectionStart ? elem.selectionStart : 0
    const selectionEnd = elem.selectionEnd ? elem.selectionEnd : 0

    // 選択範囲の文字列を取得
    const value = elem.value
    const selectionStr = value.substr(selectionStart, selectionEnd - selectionStart)

    // 選択範囲に対応するダミー要素を作成
    // デバッグ用に選択範囲を着色
    const selection = document.createElement('span')
    selection.style.color = 'white'
    selection.style.backgroundColor = 'blue'

    // (キャレットがないと0文字の場合に潰れる)
    selection.innerHTML = selectionStr.length > 0 ? selectionStr : '|'

    // 選択範囲より前
    const beforeSelection = document.createTextNode(value.substr(0, selectionStart))

    // 選択範囲より後ろ
    const afterSelection = document.createTextNode(value.substr(selectionEnd, value.length - selectionEnd))

    // 要素を設定
    cloneEl.innerHTML = ''
    cloneEl.appendChild(beforeSelection)
    cloneEl.appendChild(selection)
    cloneEl.appendChild(afterSelection)

    // 選択範囲を取得
    const bounds = {
      left: Math.min(
        selection.offsetLeft - cloneEl.offsetLeft - elem.scrollLeft,
        cloneEl.offsetWidth - selection.offsetWidth
      ),
      top: Math.min(
        selection.offsetTop - cloneEl.offsetTop - elem.scrollTop,
        cloneEl.offsetHeight - selection.offsetHeight
      ),
      width: selection.offsetWidth,
      height: selection.offsetHeight,
    }

    // ダミー要素を削除 (ここをコメントアウトするとデバッグできる)
    if (elem.offsetParent) elem.offsetParent.removeChild(cloneEl)

    return bounds
  }

  /**
   * 選択範囲の絶対座標の範囲を取得
   */
  public static getAbsoluteBounds(elem: any): { left: number; top: number; width: number; height: number } {
    const bounds = this.getBounds(elem)

    // 選択範囲左上の絶対座標 = スクロールオフセット + スクロールからテキストボックスまでの相対座標 + テキストボックス内の選択範囲左上の相対座標
    const left = window.pageXOffset + elem.getBoundingClientRect().left + bounds.left
    const top = window.pageYOffset + elem.getBoundingClientRect().top + bounds.top

    return {
      left: left,
      top: top,
      width: bounds.width,
      height: bounds.height,
    }
  }
}
